import { RouteTo } from "@routing/RouteMap";

export const LEGAL_LINKS = {
  AGB_URL: RouteTo.AGB,
  PRIVACY_URL: RouteTo.PRIVACY,
}; 